export default "__VITE_ASSET__134c91a6__"